<div class="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">{{ title() }}</h2>
      <p class="mt-1 text-sm text-slate-500">
        Add a reusable {{ typeLabel.toLowerCase() }} value for this workspace.
      </p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <form class="mt-5 flex flex-col gap-4" [signalForm]="createForm">
    <lib-signal-text-field
      label="Name"
      placeholder="e.g. Default company name"
      [formField]="createForm.name" />

    @switch (valueType) {
      @case ('text') {
        <lib-signal-text-field
          label="Value"
          placeholder="Enter text"
          [formField]="createForm.textValue" />
      }
      @case ('number') {
        <lib-signal-number-field
          label="Value"
          placeholder="Enter number"
          [formField]="createForm.numberValue" />
      }
      @case ('date') {
        <lib-signal-date-field
          label="Value"
          [formField]="createForm.dateValue" />
      }
      @case ('boolean') {
        <lib-signal-checkbox
          label="Value"
          [formField]="createForm.booleanValue" />
      }
    }

    <div class="mt-2 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
      <lib-signal-button
        appearance="outline"
        [disabled]="createState.loading()"
        (clicked)="close()">
        Cancel
      </lib-signal-button>
      <lib-signal-button
        [loading]="createState.loading()"
        [disabled]="createState.loading()"
        (clicked)="onSave()">
        Save
      </lib-signal-button>
    </div>
  </form>
</div>
